import { API } from "@/services/API";

const flattenEnrichedLoads = (enrichedLoads) =>
  enrichedLoads.map((item) => ({
    ...item.loadBoardItem,
    routeAnalysis: item.routeAnalysis,
  }));

export const fetchRequirementsLoads = async (params, signal) => {
  const res = await API.get("/parade/get-loads", {
    signal,
    params: {
      "earliest-pickup-date": params.pickupDateStart,
      "latest-pickup-date": params.pickupDateEnd,
      "earliest-delivery-date": params.deliveryDateStart ?? null,
      "latest-delivery-date": params.deliveryDateEnd ?? null,
      trailer: params.trailerType,
      "pickup-zip": params.pickup.zip,
      "pickup-state": params.pickup.stateCode,
      "delivery-zip": params.delivery?.zip ?? null,
      "delivery-state": params.delivery?.stateCode ?? null,
      "use-cache": true,
      "pickup-radius": params.pickupRadius ? parseInt(params.pickupRadius) : null,
      "delivery-radius": params.delivery?.zip && params.deliveryRadius ? parseInt(params.deliveryRadius) : null,
    },
  });
  return flattenEnrichedLoads(res).sort((a, b) => ((a.updatedAt || a.createdAt) < (b.updatedAt || b.createdAt) ? 1 : -1));
};

export const fetchTruckFilterLoads = (signal) => API.get("/parade/posted-truck-loads", { signal });
